<h2 mat-dialog-title>{{ isFolderMode ? 'Create Folder' : 'Create Document' }}</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
  <section class="hero-card">
    <div>
      <p class="eyebrow">{{ isFolderMode ? 'Knowledge Folder' : 'Knowledge Page' }}</p>
      <h3>{{ isFolderMode ? 'Organize the workspace' : 'Start a new internal page' }}</h3>
      <p>{{ isFolderMode ? 'Create a folder to group notes, SOPs, and handover materials.' : 'Create a named page with summary and content, then continue editing it in the workspace.' }}</p>
    </div>
  </section>

  <section class="form-card">
    <div class="form-grid">
      <mat-form-field appearance="outline" *ngIf="isFolderMode">
        <mat-label>Folder name</mat-label>
        <input matInput formControlName="name">
        <mat-error *ngIf="form.get('name')?.hasError('required')">Folder name is required.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="!isFolderMode">
        <mat-label>Document title</mat-label>
        <input matInput formControlName="title">
        <mat-error *ngIf="form.get('title')?.hasError('required')">Document title is required.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="!isFolderMode">
        <mat-label>File type</mat-label>
        <mat-select formControlName="documentType">
          <mat-option value="Document">Document</mat-option>
          <mat-option value="Sheet">Sheet</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ isFolderMode ? 'Parent folder' : 'Place document in' }}</mat-label>
        <mat-select formControlName="folderId">
          <mat-option [value]="null">Root workspace</mat-option>
          <mat-option *ngFor="let folder of data.folders" [value]="folder.id">{{ folder.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="!isFolderMode">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="Draft">Draft</mat-option>
          <mat-option value="In Review">In Review</mat-option>
          <mat-option value="Published">Published</mat-option>
          <mat-option value="Archived">Archived</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width" *ngIf="isFolderMode">
      <mat-label>Description</mat-label>
      <textarea matInput rows="3" formControlName="description"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width" *ngIf="!isFolderMode">
      <mat-label>Initial content</mat-label>
      <textarea matInput rows="10" formControlName="content"></textarea>
    </mat-form-field>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">
    {{ isFolderMode ? 'Create Folder' : 'Create Document' }}
  </button>
</mat-dialog-actions>
